import React from 'react'

import Header from './Header'

import Message from '@/components/common/Message'


interface Props {
  children: React.ReactNode
}

const Main: React.FC<Props> = ({ children }) => {
  return (
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
      {/* 消息提示区域 - fixed定位不参与flex布局 */}
      <Message />
      {/* Header - 固定高度 */}
      <Header />
      {/* Main content - 占据剩余空间 */}
      <main className="flex-1 min-h-0 overflow-y-auto">
        <div className="max-w-7xl mx-auto p-4 sm:p-5 lg:p-6">{children}</div>
      </main>
      {/* <Footer /> */}
    </div>
  )
}

export default Main
